import React from "react";
import { Setup } from "./Setup";
import { Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import NoTenantDashboard from "../NoTenantDashboard/NoTenantDashboard";

const AgencyOnboardingContainer = () => {
  const match = useRouteMatch();
  const hasBackButton = true;
  const parentPath = "/agency-setup";

  const history = useHistory();
  const { location } = history;
  const { state } = location ? location : {};
  const { previousPath } = state ? state : {};

  return (
    <Switch>
      <Route path={`${match.path}/agencyIQ`}>
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <NoTenantDashboard
            hasBackButton={hasBackButton}
            parentPath={previousPath ? previousPath : parentPath}
            isBasicPlanOrSetup={true}
          />
        </div>
      </Route>
      <Route path={`${match.path}`}>
        <Setup />
      </Route>
    </Switch>
  );
};

export default AgencyOnboardingContainer;
